import React from "react";
import { useI18n } from "@/context/I18nContext";

const STATUS_STYLES = {
  new: { bg: "bg-slate-100", text: "text-slate-700", el: "Νέα", en: "New" },
  called: { bg: "bg-blue-100", text: "text-blue-800", el: "Κλήση", en: "Called" },
  callback_scheduled: { bg: "bg-amber-100", text: "text-amber-800", el: "Επανάκληση", en: "Callback" },
  meeting_scheduled: { bg: "bg-cyan-100", text: "text-cyan-800", el: "Ραντεβού", en: "Meeting" },
  proposal_sent: { bg: "bg-violet-100", text: "text-violet-800", el: "Πρόταση", en: "Proposal" },
  not_interested: { bg: "bg-red-100", text: "text-red-700", el: "Δεν ενδιαφέρεται", en: "Not interested" },
  won: { bg: "bg-emerald-100", text: "text-emerald-800", el: "Κερδισμένη", en: "Won" },
  lost: { bg: "bg-slate-200", text: "text-slate-700", el: "Χαμένη", en: "Lost" },
};

export default function StatusBadge({ status, className = "" }) {
  const { lang } = useI18n();
  const L = lang === "el";
  const s = STATUS_STYLES[status] || STATUS_STYLES.new;
  return (
    <span className={`inline-block text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded ${s.bg} ${s.text} ${className}`}>
      {L ? s.el : s.en}
    </span>
  );
}

export const STATUS_LIST = ["new", "called", "callback_scheduled", "meeting_scheduled", "proposal_sent", "not_interested", "won", "lost"];
export const STATUS_LABELS = STATUS_STYLES;
